import { render, staticRenderFns } from "./ColumnTransactionStatusCelcoin.vue?vue&type=template&id=97ac45d4&scoped=true"
import script from "./ColumnTransactionStatusCelcoin.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusCelcoin.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusCelcoin.vue?vue&type=style&index=0&id=97ac45d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ac45d4",
  null
  
)

export default component.exports